export default __webpack_public_path__ + "static/media/18-TheGetaway.ee3d952f.jpeg";